// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
export default function (o) {
  var r = {};

  for (var k in o) {
    if (o.hasOwnProperty(k)) {
      r[k] = o[k];
    }
  }

  return r;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/twitter-text/dist/esm/lib/clone.js
// module id = 67
// module chunks = 110